import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../core/utils';
import { addSelectedFilterItemAction, MODEL_YEAR_FILTER_CATEGORY } from '../../../core/reducers/vehicleListFilters';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
const useYearFilterPreSelect = (isInventoryVariant) => {
    const { modelYear } = useAppSelector(selectCurrentVehicle);
    const dispatch = useDispatch();
    useEffect(() => {
        if (modelYear && isInventoryVariant)
            dispatch(addSelectedFilterItemAction(`${MODEL_YEAR_FILTER_CATEGORY}|${modelYear}`));
    }, [modelYear, dispatch, isInventoryVariant]);
};
export default useYearFilterPreSelect;
